Ext.define('SA.view.settings.ChangePasswordWindow', {
    alias: 'widget.change-password-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-change-password-window',
    includeCancelBtn: true,
    title: 'Change Password',

    initComponent() {
        this.callParent();

        ['oldPassword', 'newPassword', 'newPasswordAgain'].forEach(name => {
            var field = this[name] = this.down('#' + name);

            field.on({
                blur: this.refreshErrors,
                change: this.refreshErrors,
                focus: this.refreshErrors,

                scope: this
            });
        });

        this.saveButton = this.down('#saveButton');
    },

    afterRender() {
        this.callParent();

        this.oldPassword.focus();
    },

    getBodyItems() {
        return [
            {
                xtype: 'simple-container',
                cls: 'sa-change-password-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-password-window-field-label',
                        html: 'Old password:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-password-window-field-input',
                        height: 35,
                        inputType: 'password',
                        itemId: 'oldPassword'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-change-password-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-password-window-field-label',
                        html: 'New password:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-password-window-field-input',
                        height: 35,
                        inputType: 'password',
                        itemId: 'newPassword'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-change-password-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-password-window-field-label',
                        html: 'Retype new password:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-password-window-field-input',
                        height: 35,
                        inputType: 'password',
                        itemId: 'newPasswordAgain'
                    }
                ]
            }
        ];
    },

    getFooterItems() {
        return {
            xtype: 'sa-button',
            disabled: true,
            handler: this.onSaveClick.bind(this),
            itemId: 'saveButton',
            text: 'Save',
            ui: 'primary'
        };
    },

    onSaveClick() {
        this.setLoading('Updating password…');

        SA.Ajax.request({
            method: 'update',
            resource: 'user/password',
            expectedErrors: ['InvalidUserCredentialsException'],

            data: {
                newPassword: this.newPassword.getValue(),
                oldPassword: this.oldPassword.getValue()
            }
        }).then(() => {
            SA.msg('Your password has been changed.');

            this.destroy();
        }).catch(error => {
            if (!error.hasType('InvalidUserCredentialsException')) {
                return;
            }

            Ext.widget({
                xtype: 'alert',
                message: 'Your password could not be changed.\n\nThe old password you’ve provided may be incorrect.',
                title: 'Change Failed'
            });

            this.setLoading(false);
        });
    },

    refreshErrors() {
        var newPasswordField = this.newPassword,
            newPassword = newPasswordField.getValue(),
            newPasswordLength = newPassword.length,
            newPasswordAgainField = this.newPasswordAgain,
            newPasswordAgain = newPasswordAgainField.getValue(),
            newPasswordAgainLength = newPasswordAgain.length,
            valid = true;

        newPasswordField.clearInvalid();
        newPasswordAgainField.clearInvalid();

        if (newPasswordLength < 6) {
            valid = false;

            if (newPasswordLength) {
                newPasswordField.markInvalid('The minimum length for a new password is 6 characters');
            }
        }
        else if (/\s/.test(newPassword)) {
            valid = false;

            newPasswordField.markInvalid('Passwords must not contain spaces');
        }
        else if (newPassword === this.oldPassword.getValue()) {
            valid = false;

            newPasswordField.markInvalid('Your new password must be different from your old password');
        }
        else if (newPassword !== newPasswordAgain) {
            valid = false;

            if (newPasswordAgainLength) {
                newPasswordAgainField.markInvalid('This entry must match the new password entered above');
            }
        }

        this.saveButton.setDisabled(!valid);
    }
});
